import React, { useContext, useState } from 'react';
import { updateSubmission } from '../../../Mutations/update-submission-mutation';
import { createIframeUpdate } from '../../helpers';
import { SubmissionContext } from '../../../Context/SubmissionProvider';
import ActionLink, { ActionLinkButton } from '../../../../../../Footer/ActionLink';
import SubmissionTabVersionsNotifications from './SubmissionTabVersionsNotifications';
import { AccordionSection } from '../../../../../Admin/Game/GameTab/utils';
import SubmissionOverviewGameBuilds from '../SubmissionOverviewGameBuilds';
import Feedback from '../../../../../../../../common/components/Feedback';

type SubmissionTabVersionsProps = {
  createNewGameBuild(): void;
};

const SubmissionTabVersions: React.FC<SubmissionTabVersionsProps> = ({ createNewGameBuild }) => {
  const { submission, gameBuild, baseForm, detailsForm, isNonEditable } = useContext(SubmissionContext);
  const [isSaving, setIsSaving] = useState(false);

  if (!submission) {
    return null;
  }

  // NOTIFICATIONS
  const renderNotifications = () => {
    return <SubmissionTabVersionsNotifications />;
  };

  // HISTORY
  const renderHistory = () => {
    return (
      <AccordionSection title="Version History" defaultExpanded>
        <SubmissionOverviewGameBuilds submission={submission} />
      </AccordionSection>
    );
  };

  // TEAM FEEDBACKS
  const renderTeamFeedbacks = () => {
    return (
      <AccordionSection title="Team feedback">
        <Feedback feedback={submission.feedback} />
      </AccordionSection>
    );
  };
  const showTeamFeedback = submission.feedback.length > 0 && submission.status !== 'DRAFT';

  // ACTION LINKS
  const renderActionLinks = () => {
    const primaryButton: ActionLinkButton | undefined = isNonEditable
      ? undefined
      : {
          title: 'Submit new version',
          callback: () => createNewGameBuild(),
        };

    const isIframe = gameBuild?.loaderType === 'iframe';
    const handleIframeUpdate = async () => {
      await createIframeUpdate(submission!, baseForm!, detailsForm!, setIsSaving, updateSubmission);
    };
    const middleButton: ActionLinkButton | undefined =
      isIframe && !isNonEditable
        ? {
            title: 'Go to QA and notify admins of changes',
            callback: () => handleIframeUpdate(),
            isLoading: isSaving,
            tooltip: 'If you updated your iframe, you need to go to QA and notify the admins of the change.',
            color: 'white',
          }
        : undefined;

    return <ActionLink primaryButton={primaryButton} middleButton={middleButton} />;
  };
  const showActionLinks = submission.status !== 'REJECTED';

  return (
    <>
      {renderNotifications()}
      {renderHistory()}
      {showTeamFeedback && renderTeamFeedbacks()}
      {showActionLinks && renderActionLinks()}
    </>
  );
};

export default SubmissionTabVersions;
